import { isHiringResumeDocumentId, isHiringResumeLeadId } from './hiringResumeViewer';
import { isPurchaseAttachmentDocumentId, isPurchasingViewerLeadId } from './purchasingAttachmentViewer';

export const UNTAGGED_COMMENT_WARNING =
  "Nobody's tagged. Nobody will be notified. Click again to continue.";

/** Hiring resumes notify admins, and purchasing attachments notify employees and admins, even with no tag. */
export function fileCommentNotifiesWithoutMention(
  leadId?: string | null,
  documentId?: string | null,
): boolean {
  return (
    isHiringResumeLeadId(leadId) ||
    isHiringResumeDocumentId(documentId) ||
    isPurchasingViewerLeadId(leadId) ||
    isPurchaseAttachmentDocumentId(documentId)
  );
}

export function mentionsNotifySomeone(
  mentions: Array<{ userId?: string | null }> | null | undefined,
  authorId?: string | null,
): boolean {
  const author = (authorId || '').trim();
  return (mentions || []).some((mention) => {
    const id = String(mention?.userId || '').trim();
    if (!id) return false;
    if (author && id === author) return false;
    return true;
  });
}

export type UntaggedSendSource = 'click' | 'keyboard';

/** First untagged submit shows the warning. A later click on send is what posts the comment. */
export function nextUntaggedSendGate(input: {
  tagged: boolean;
  source: UntaggedSendSource;
  awaitingClick: boolean;
  /** Someone is still notified when nobody is tagged (hiring admins, task assignees, purchasing). */
  skip?: boolean;
}): { action: 'send' | 'confirm'; awaitingClick: boolean } {
  if (input.skip || input.tagged) {
    return { action: 'send', awaitingClick: false };
  }
  if (input.source === 'click' && input.awaitingClick) {
    return { action: 'send', awaitingClick: false };
  }
  return { action: 'confirm', awaitingClick: true };
}
